import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../../components/sheet'
import { type FC, type ReactNode } from 'react'
import { Separator } from '../../components/separator'
import { ScrollArea } from '../../components/scroll-area'

type DrawerProps = {
  open: boolean
  setOpen: (open: boolean) => void
  title?: ReactNode
  children?: ReactNode
  side?: 'left' | 'right'
  /** Override the sheet width (defaults to lg:max-w-[666px]). */
  contentClassName?: string
}
const Drawer: FC<DrawerProps> = ({
  open,
  setOpen,
  title,
  children,
  side = 'right',
  contentClassName = 'lg:max-w-[666px]'
}) => {
  const positionClass =
    side === 'left'
      ? 'top-0 sm:top-[20px] left-0 sm:left-[20px] sm:max-w-none'
      : 'top-0 sm:top-[20px] right-0 sm:right-[20px] sm:max-w-none'

  return (
    <Sheet open={open} onOpenChange={setOpen} modal={false}>
      <SheetContent
        side={side}
        className={`bg-white border-0 sm:border sm:border-[#E9EAEB] w-full sm:w-auto ${contentClassName} ${positionClass} h-full sm:h-[calc(100%-40px)] rounded-none sm:rounded-[8px] flex flex-col`}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <SheetHeader className="p-0 gap-0">
          <SheetTitle className="text-body1 font-normal leading-[100%] py-[12px] px-[16px]">
            {title}
          </SheetTitle>
          <Separator className="bg-[#E9EAEB]" />
        </SheetHeader>
        <ScrollArea className="px-[16px] pb-[20px] flex-1 overflow-auto">
          {children}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  )
}

export default Drawer